/* eslint-disable react/prop-types */
import React from 'react';

const BrandingDesktop = ({ fill = '#6B6C7B' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_307_16602"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill={fill} />
    </mask>
    <g mask="url(#mask0_307_16602)">
      <path
        d="M13 16H5.375M4.7973 13.375C3.81912 13.375 3.3293 13.375 2.95532 13.1844C2.62604 13.0167 15.1678 12.8293 15 12.5C14.8941 12.2922 2.03776 11.9679 2.0168 11.625M4.7973 13.375H13.2027M4.7973 13.375H3.39966C2.90961 13.375 2.66483 13.3747 2.47766 13.2793C2.31302 13.1954 2.17926 13.0626 2.09537 12.8979C2 12.7108 2 12.465 2 11.975V11.5L2.0168 11.625M2.0168 11.625C2 11.3501 2 11.0112 2 10.5752V4.80017C2 3.82008 2 3.32967 2.19074 2.95532C2.35852 2.62604 2.62604 2.35852 2.95532 2.19074C3.32967 2 3.82008 2 4.80017 2H13.2002C14.1803 2 14.6696 2 15.044 2.19074C15.3733 2.35852 15.6417 2.62604 15.8094 2.95532C16 3.3293 16 3.81912 16 4.7973V10.5777C16 11.0125 16 11.3506 15.9833 11.625M2.0168 11.625H15.9833M15.9833 11.625C15.9624 11.9679 15.9153 12.2112 15.8094 12.419C15.6417 12.7483 15.3733 13.0167 15.044 13.1844C14.67 13.375 14.1809 13.375 13.2027 13.375M15.9833 11.625H16V11.975C16 12.465 15.9997 12.7108 15.9043 12.8979C15.8204 13.0626 15.6871 13.1954 15.5224 13.2793C15.3352 13.3747 15.0897 13.375 14.5997 13.375H13.2027"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default BrandingDesktop;
